import { Redirect, Route } from 'react-router-dom'
import { setTitle } from './../actions/ui'

import React from 'react'
import propTypes from 'prop-types'
import { useDispatch } from 'react-redux'

const PrivateRoute = ({ isAuthenticated, component: Component, ...rest }) => {
  localStorage.setItem('lastPath', rest.location.pathname)
  const dispatch = useDispatch()
  React.useEffect(() => {
    if (rest.location.pathname.includes('/dashboard')) dispatch(setTitle('Dashboard'))
    else if (rest.location.pathname.includes('/first-mile')) dispatch(setTitle('Primera Milla'))
    else if (rest.location.pathname.includes('/sorting')) dispatch(setTitle('Sorting'))
    else if (rest.location.pathname.includes('/dispatch')) dispatch(setTitle('Despacho'))
    else if (rest.location.pathname.includes('/wms')) dispatch(setTitle('Gestión Almacen'))
    else if (rest.location.pathname.includes('/reverse-logistic')) dispatch(setTitle('Logística Inversa'))
    else if (rest.location.pathname.includes('/search')) dispatch(setTitle('Busqueda'))
    else if (rest.location.pathname.includes('/control-gestion')) dispatch(setTitle('Control de gestión'))
    else if (rest.location.pathname.includes('/tools')) dispatch(setTitle('Control de gestión'))
    else if (rest.location.pathname.includes('/mantenedores/cierre')) dispatch(setTitle('Cierre'))
    else if (rest.location.pathname.includes('/mantenedores/directorio')) dispatch(setTitle('Directorio'))
    else if (rest.location.pathname.includes('/mantenedores/empresas')) dispatch(setTitle('Empresas'))
    else if (rest.location.pathname.includes('/mantenedores/estados')) dispatch(setTitle('Estados y Sub Estados'))
    else if (rest.location.pathname.includes('/mantenedores/extras')) dispatch(setTitle('Extras'))
    else if (rest.location.pathname.includes('/mantenedores/rutas-conductores')) dispatch(setTitle('Rutas de Conductores'))
    else if (rest.location.pathname.includes('/mantenedores/tarifarios')) dispatch(setTitle('Tarifarios'))
    else if (rest.location.pathname.includes('/mantenedores/usuarios')) dispatch(setTitle('Usuarios'))
    else if (rest.location.pathname.includes('/mantenedores/test-usuario')) dispatch(setTitle('Test Usuario'))
    else if (rest.location.pathname.includes('/mantenedores/generales')) dispatch(setTitle('Generales'))
    else if (rest.location.pathname.includes('/mantenedores')) dispatch(setTitle('Mantenedores'))
  }, [rest.location.pathname])
  return (
    <Route
      {...rest}
      component={props => (isAuthenticated ? <Component {...props} /> : <Redirect to="/auth" />)}
    />
  )
}

PrivateRoute.propTypes = {
  isAuthenticated: propTypes.bool.isRequired,
  component: propTypes.func.isRequired
}

export default PrivateRoute